// actions/connect/token.js

//import { attachAuth } from '../../utils/authService';
import PubSub         from 'pubsub-js';

// --- ALL ---

export function connectTokenHasErrored(bool) {
  return {
    type: 'CONNECT_TOKEN_HAS_ERRORED',
    hasErrored: bool
  };
}

export function connectTokenIsLoading(bool) {
  return {
    type: 'CONNECT_TOKEN_IS_LOADING',
    isLoading: bool
  };
}

export function connectTokenFetchDataSuccess(obj) {
  return {
    type: 'CONNECT_TOKEN_FETCH_DATA_SUCCESS',
    obj
  };
}

export function connectTokenFetchData(host, userId) {
  return (dispatch) => {
    dispatch(connectTokenIsLoading(true));
    dispatch(connectTokenHasErrored(false));
    fetch(host + 'connect/token', {
      method: 'post',
      body: JSON.stringify({ Username: userId }),
    }).then(promise => {
        if (!promise.ok) {
          throw Error(promise.statusText);
        }
        
        promise.json()
          .then(result => {
            dispatch(connectTokenFetchDataSuccess(result));
            dispatch(connectTokenHasErrored(false));
            dispatch(connectTokenIsLoading(false));
            PubSub.publish('connect.chat.token', result);
          })
          .catch((ex) => {
            console.log(ex);
            dispatch(connectTokenHasErrored(true));
            dispatch(connectTokenIsLoading(false));
            PubSub.publish('connect.chat.token.error');
          });
    })
    .catch((ex) => {
      console.log(ex);
      dispatch(connectTokenHasErrored(true));
      dispatch(connectTokenIsLoading(false));
      PubSub.publish('connect.chat.token.error');
    });
  };
}